<template>
    <modal name="message-user" class="py-5" height="auto" :adaptive="true" width="90%" :max-width="600" :scrollable="true">
        <div class="modal-content">
            <div class="modal-header bg-ah-orange">
                <h4 class="modal-title">Send message to: {{ username }}</h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$modal.hide('message-user')">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <form @submit.prevent="submit">
                <div class="modal-body">
                    <textarea name="message" v-model="form.data.message" class="form-control" rows="5" :placeholder="placeholderMessage" style="font-size:16px;" required minlength="15"></textarea>
                </div>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-black-soft">Send Message</button>
                </div>
            </form>
        </div>
    </modal>
</template>

<script>
    import Form from './../core/Form';

    export default {
        props: {
            username: {
                required: true,
                type: String,
            },
            title: {
                required: false,
                type: String,
            },
            itemId: {
                required: false,
                type: Number,
            },
            userId: {
                required: false,
                type: Number,
            },
        },

        data() {
            return {
                form: new Form({
                    message: '',
                    'item_id': this.itemId,
                    'user_id': this.userId,
                }),
            };
        },

        computed: {
            placeholderMessage() {
                return 'Enter a message to send to ' + this.username + (this.title ? ' ' + this.title : '') + '...';
            },
        },

        methods: {
            submit() {
                this.$emit('loading', true);

                this.form.submit('post', route('message-centre'))
                    .then(response => {
                        this.$modal.hide('message-user');
                        this.$emit('messagesent', true);
                    })
                    .catch(error => console.log(error))
                    .finally(() => this.$emit('loading', false));
            },
        },
    };
</script>
